import { Component, inject } from '@angular/core'
import { OAuthService } from 'angular-oauth2-oidc'

@Component({
    selector: 'lg-user-not-authenticated',
    templateUrl: './user-not-authenticated.component.html'
})
export class UserNotAuthenticatedComponent {
  oAuthService = inject(OAuthService);


  logout() {
    this.oAuthService.logOut({
      client_id: this.oAuthService.clientId,
      redirect_uri: this.oAuthService.redirectUri,
      response_type: 'code',
    })
  }
}
